var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttatchment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 5.83339L7.08358 11.2501C6.75206 11.5816 6.56582 12.0312 6.56582 12.5001C6.56582 12.9689 6.75206 13.4185 7.08358 13.7501C7.4151 14.0816 7.86474 14.2678 8.33359 14.2678C8.80243 14.2678 9.25207 14.0816 9.58359 13.7501L15.0003 8.33339C15.6633 7.67034 16.0358 6.77107 16.0358 5.83339C16.0358 4.8957 15.6633 3.99643 15.0003 3.33339C14.3372 2.67034 13.4379 2.29785 12.5003 2.29785C11.5626 2.29785 10.6633 2.67034 10.0003 3.33339L4.58358 8.75005C3.58901 9.74461 3.03027 11.0935 3.03027 12.5001C3.03027 13.9066 3.58901 15.2555 4.58358 16.2501C5.57814 17.2446 6.92706 17.8034 8.33359 17.8034C9.74011 17.8034 11.089 17.2446 12.0836 16.2501L17.5003 10.8334",
    stroke: "#B91C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttatchment);
export default __webpack_public_path__ + "static/media/attatchment.a2aff6b9129024f1bb7ac35ac054a3a2.svg";
export { ForwardRef as ReactComponent };